"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinListType = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var commonTypes_1 = require("../../shared/types/commonTypes");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var getFetchHeaders_1 = __importDefault(require("../../shared/util/getFetchHeaders"));
var translateMessage_1 = __importDefault(require("../../shared/util/translateMessage"));
var messageTypes_1 = require("../../shared/types/messageTypes");
var deleteEntityData_1 = __importDefault(require("../../fetch/deleteEntityData"));
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var crude_actions_1 = require("../../store/crude/crude.actions");
var createEntityData_1 = __importDefault(require("../../fetch/createEntityData"));
var DataEditView_1 = __importDefault(require("../DataEditView/DataEditView"));
var CrudeDialogComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/CrudeDialogComponent"));
var styles_1 = require("@mui/styles");
var JoinEntityElement_1 = __importDefault(require("../DataTableView/JoinEntityElement"));
var SearchComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/SearchComponent"));
var FilterComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/FilterComponent"));
var ButtonComponent_1 = __importDefault(require("../../shared/components/FormComponents/ButtonComponent"));
var FilterAlt_1 = __importDefault(require("@mui/icons-material/FilterAlt"));
var DialogComponent_1 = __importDefault(require("../../shared/components/MessageComponents/DialogComponent"));
var JoinListType;
(function (JoinListType) {
    JoinListType["entityList"] = "entityList";
    JoinListType["joinList"] = "joinList";
})(JoinListType = exports.JoinListType || (exports.JoinListType = {}));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    paper: {
        border: "2px solid " + theme.palette.grey.A200,
        boxShadow: 'none !important',
    },
    filterButton: {
        '& .MuiButton-startIcon': {
            marginLeft: 0,
            marginRight: 0,
        },
        '& .MuiButton-root': {
            borderColor: theme.palette.primary.main,
            border: '1px solid',
            minWidth: '48px',
            '&.Mui-disabled ': {
                borderColor: theme.palette.grey.A200,
            },
        },
    },
}); });
var ResponsiveJoinEntity = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var classes = useStyles();
    var temporaryJoinData = react_redux_1.useSelector(crude_selector_1.getTemporaryJoinData);
    var theme = react_redux_1.useSelector(crude_selector_1.getTheme);
    var _j = react_1.default.useState(props.entity), entity = _j[0], setEntity = _j[1];
    var _k = react_1.default.useState(props.joinEntity), joinEntity = _k[0], setJoinEntity = _k[1];
    var _l = react_1.useState(false), showFilter = _l[0], setShowFilter = _l[1];
    var _m = react_1.useState(), tempFilter = _m[0], setTempFilter = _m[1];
    react_1.useEffect(function () {
        setEntity(props.entity);
        setJoinEntity(props.joinEntity);
    }, [props.entity, props.joinEntity]);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var mainEntity = react_redux_1.useSelector(crude_selector_1.getActiveEntity);
    var joinEntityDescription = ((_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[joinEntity]) === null || _b === void 0 ? void 0 : _b.description) || ((_d = (_c = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _c === void 0 ? void 0 : _c.entity[joinEntity]) === null || _d === void 0 ? void 0 : _d.title) || joinEntity;
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var joinEntitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === joinEntity; });
    var setTemporaryData = function (tempJoinEntityData) {
        var _a;
        // hier werden die Daten temporär gesetzt, damit die Anzeige im FE das Anlegen und Löschen der JoinEntites simulieren kann
        var newEntityData = __spreadArrays(entityData.data);
        var newJoinData = [];
        var joinColumns = joinEntitySchema && joinEntitySchema.columns;
        tempJoinEntityData.data.map(function (join) {
            var chosenElement = false;
            joinColumns && joinColumns.forEach(function (column) {
                var _a;
                if ((joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && ((_a = temporaryJoinData[joinEntity]) === null || _a === void 0 ? void 0 : _a.find(function (temp) { return temp.data[column.name] === join[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; }))) {
                    chosenElement = true;
                }
            });
            if (chosenElement) {
                if (!newEntityData.find(function (elem) { return JSON.stringify(elem) === JSON.stringify(join); })) {
                    newEntityData.push(join);
                }
            }
            else {
                if (!newJoinData.find(function (elem) { return JSON.stringify(elem) === JSON.stringify(join); })) {
                    newJoinData.push(join);
                }
            }
        });
        newEntityData.map(function (rejoin) {
            var chosenElement = false;
            joinColumns && joinColumns.forEach(function (column) {
                var _a;
                if ((joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && ((_a = temporaryJoinData[joinEntity]) === null || _a === void 0 ? void 0 : _a.find(function (temp) { return temp.data[column.name] === rejoin[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; }))) {
                    chosenElement = true;
                }
            });
            if (!chosenElement) {
                // prüfen, ob noch in EntityListe und ggf. entfernen
                joinColumns && joinColumns.forEach(function (column) {
                    if (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) {
                        var id = newEntityData.findIndex(function (elem) {
                            return elem[column.name] === rejoin[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                        });
                        if (id >= 0) {
                            newEntityData.splice(id, 1);
                        }
                    }
                });
            }
        });
        var newReferences = entityData.entityReferencePreviews[entity]
            ? Object.assign(entityData.entityReferencePreviews[entity], tempJoinEntityData.entityReferencePreviews[entity])
            : tempJoinEntityData.entityReferencePreviews[entity];
        setEntityData(__assign(__assign({}, entityData), { data: newEntityData, entityReferencePreviews: (_a = {}, _a[entity] = newReferences, _a) }));
        setJoinEntityData(__assign(__assign({}, tempJoinEntityData), { data: newJoinData, totalPages: tempJoinEntityData.totalPages, totalElements: tempJoinEntityData.totalElements }));
    };
    var initialData = function (data) {
        var preparedData;
        if (data && data.data) {
            preparedData = data;
        }
        else {
            preparedData = {
                data: [],
                instancePermissions: {},
                entityReferencePreviews: {},
                thumbnailData: {},
                hasChildren: {},
                joinContext: {},
                totalPages: 0,
                totalElements: 0,
            };
        }
        preparedData.data.map(function (element) {
            element.selected = false;
            return element;
        });
        return preparedData;
    };
    var _o = react_1.default.useState(initialData(props.entityData)), entityData = _o[0], setEntityData = _o[1];
    var _p = react_1.default.useState(initialData(props.joinEntityData)), joinEntityData = _p[0], setJoinEntityData = _p[1];
    var _q = react_1.default.useState(), singleEntity = _q[0], setSingleEntity = _q[1];
    react_1.useEffect(function () {
        setEntityData(props.entityData);
        setJoinEntityData(props.joinEntityData);
        props.mainEntityId === 'new' && setTemporaryData(props.joinEntityData);
    }, [props.entityData, props.joinEntityData]);
    react_1.useEffect(function () {
        props.mainEntityId === 'new' && setEntityData({
            data: [],
            instancePermissions: {},
            entityReferencePreviews: {},
            thumbnailData: {},
            hasChildren: {},
            joinContext: {},
            totalPages: 0,
            totalElements: 0,
        });
    }, [props.joinEntity]);
    var getInitialFilterSettings = function () {
        return __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel]), { page: 0, search: '', pageSize: (appLayout === null || appLayout === void 0 ? void 0 : appLayout.initialPageSize) || 15, filter: {} });
    };
    var _r = react_1.useState(getInitialFilterSettings()), entityFilterSettings = _r[0], setEntityFilterSettings = _r[1];
    var _s = react_1.default.useState(getInitialFilterSettings()), joinFilterSettings = _s[0], setJoinFilterSettings = _s[1];
    var _t = react_1.useState(), fetchResponse = _t[0], setFetchResponse = _t[1];
    react_1.useEffect(function () {
        var rowsPerPageOptions = (appLayout === null || appLayout === void 0 ? void 0 : appLayout.rowsPerPageOptions) || [10, 25, 50, 100];
        setEntityFilterSettings(__assign(__assign({}, entityFilterSettings), { page: 0, pageSize: rowsPerPageOptions[0] }));
        setJoinFilterSettings(__assign(__assign({}, joinFilterSettings), { page: 0, pageSize: rowsPerPageOptions[0] }));
    }, [entity]);
    react_1.useEffect(function () {
        props.changeEntityFilterSettings && props.changeEntityFilterSettings(entityFilterSettings);
    }, [entityFilterSettings]);
    react_1.useEffect(function () {
        props.changeJoinFilterSettings && props.changeJoinFilterSettings(joinFilterSettings);
    }, [joinFilterSettings]);
    react_1.useEffect(function () {
        if (fetchResponse) {
            props.reloadJoinEntityData && props.reloadJoinEntityData();
            if (crudeLabels && fetchResponse.message) {
                var text = translateMessage_1.default(fetchResponse.message, crudeLabels, props.entity);
                var message = {
                    eventType: fetchResponse.eventType,
                    severity: fetchResponse.status && fetchResponse.status < 400 ? messageTypes_1.Severity.success : messageTypes_1.Severity.error,
                    message: text,
                };
                fetchResponse && dispatch(crudeActions.addMessage(message));
            }
        }
    }, [fetchResponse]);
    var disabledJoinColumns = [
        props.embeddingEntityFilter.key,
    ];
    ((_f = (_e = crudeSchema === null || crudeSchema === void 0 ? void 0 : crudeSchema.find(function (elem) { return elem.name === entity; })) === null || _e === void 0 ? void 0 : _e.incomingReferences.find(function (elem) { return elem.sourceEntity === joinEntity; })) === null || _f === void 0 ? void 0 : _f.sourceColumn) &&
        disabledJoinColumns.push((_h = (_g = crudeSchema === null || crudeSchema === void 0 ? void 0 : crudeSchema.find(function (elem) { return elem.name === entity; })) === null || _g === void 0 ? void 0 : _g.incomingReferences.find(function (elem) { return elem.sourceEntity === joinEntity; })) === null || _h === void 0 ? void 0 : _h.sourceColumn);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Grid, { xs: 12, container: true },
            react_1.default.createElement(material_1.Grid, { xs: 9, item: true },
                react_1.default.createElement(SearchComponent_1.default, { fullWidth: true, dataViewType: commonTypes_1.DataViewType.referenceView, entity: entity, treeviewLevel: props.treeViewLevel })),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'right' },
                react_1.default.createElement(material_1.Box, { style: { textAlign: 'right' }, className: classes.filterButton },
                    react_1.default.createElement(ButtonComponent_1.default, { onClick: function () { return setShowFilter(true); }, color: 'primary', variant: 'text', startIcon: react_1.default.createElement(FilterAlt_1.default, null) })),
                react_1.default.createElement(DialogComponent_1.default, { title: react_1.default.createElement(react_1.default.Fragment, null, t('crude:filter')), content: react_1.default.createElement(material_1.Box, { sx: { marginTop: theme.spacing(2) } },
                        react_1.default.createElement(FilterComponent_1.default, { entity: entity, treeviewLevel: props.treeViewLevel, dataViewType: commonTypes_1.DataViewType.referenceView, onChangeFilter: function (filter) { return setTempFilter(filter); } })), request: true, open: showFilter, onClose: function () { return setShowFilter(false); }, confirmLabel: t('crude:useFilter'), cancelLabel: t('crude:defaultFilter'), autoClose: false, onConfirm: function () {
                        tempFilter && dispatch(crudeActions.setTableFilterSettings(tempFilter));
                        setShowFilter(false);
                    }, onCancel: function () {
                        var _a, _b;
                        if (entity) {
                            var changeSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = __assign(__assign({}, storedTableFilterSettings[entity][0]), { page: 0, filter: {} }), _b)), _a));
                            dispatch(crudeActions.setTableFilterSettings(changeSettings));
                        }
                        setShowFilter(false);
                    } }))),
        react_1.default.createElement(material_1.Divider, { sx: { my: 3 } }),
        react_1.default.createElement(material_1.Paper, { className: classes.paper },
            react_1.default.createElement(material_1.Typography, { variant: 'body2' },
                react_1.default.createElement("b", null, joinEntityDescription)),
            react_1.default.createElement(material_1.List, null,
                react_1.default.createElement(react_1.default.Fragment, null,
                    entityData.data.map(function (entityElement, index) {
                        var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && entityElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                        var joinEntityId = entityData.joinContext[entityElement.id] ? entityData.joinContext[elementId].id : undefined;
                        return (react_1.default.createElement(JoinEntityElement_1.default, { data: __assign(__assign({}, entityElement), { selected: true }), thumbnailData: entityData.thumbnailData[elementId], joinContext: entityData.joinContext[elementId], schema: joinEntitySchema, joinEntityId: joinEntityId, entityReferencePreviews: entityData.entityReferencePreviews, joinEntityReferencePreviews: joinEntityData.entityReferencePreviews, treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, entity: entity, joinEntity: joinEntity, key: index, joinListType: JoinListType.entityList, editEntity: function (element) { return setSingleEntity(element); }, selectEntity: function (id, checked) {
                                var newList = entityData;
                                var newData = __spreadArrays(newList.data);
                                newData.map(function (element) {
                                    if (element.id === id) {
                                        element.selected = checked;
                                    }
                                    return element;
                                });
                                newList.data = newData;
                                setEntityData(newList);
                                if (id === 'new') {
                                    var joinColumns = joinEntitySchema && joinEntitySchema.columns;
                                    var tempArray_1 = temporaryJoinData[joinEntity] ? __spreadArrays(temporaryJoinData[joinEntity]) : [];
                                    var newArray_1 = [];
                                    joinColumns && joinColumns.forEach(function (column) {
                                        var changeElement = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && tempArray_1.find(function (elem) { return elem.data[column.name] === entityElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; });
                                        if (changeElement) {
                                            var index_1 = tempArray_1.findIndex(function (object) { return object.data[column.name] === changeElement.data[column.name]; });
                                            if (index_1 >= 0) {
                                                tempArray_1.map(function (elem, id) {
                                                    if (index_1 !== id) {
                                                        newArray_1.push(elem);
                                                    }
                                                });
                                            }
                                        }
                                    });
                                    var newTempJoinData = __assign({}, temporaryJoinData);
                                    newTempJoinData[joinEntity] = newArray_1;
                                    props.mainEntityId === 'new' && dispatch(crudeActions.setTemporaryJoinData(newTempJoinData));
                                }
                                else {
                                    var entityId = entityData.joinContext[id].id;
                                    deleteEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, fetchHeaders, entityId, setFetchResponse);
                                }
                            } }));
                    }),
                    joinEntityData.data.map(function (entityElement, index) {
                        return react_1.default.createElement(JoinEntityElement_1.default, { data: entityElement, schema: joinEntitySchema, entityReferencePreviews: entityData.entityReferencePreviews, joinEntityReferencePreviews: joinEntityData.entityReferencePreviews, treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, entity: entity, joinEntity: joinEntity, key: index, joinListType: JoinListType.joinList, editEntity: function (element) { return setSingleEntity(element); }, selectEntity: function (id, checked) {
                                var newList = joinEntityData;
                                var newData = __spreadArrays(newList.data);
                                newData.map(function (element) {
                                    if (element.id === id) {
                                        element.selected = checked;
                                    }
                                    return element;
                                });
                                newList.data = newData;
                                setJoinEntityData(newList);
                                var joinColumns = joinEntitySchema && joinEntitySchema.columns;
                                var tempArray = temporaryJoinData[joinEntity] ? __spreadArrays(temporaryJoinData[joinEntity]) : [];
                                // createdElement ist das gewählte Element für den ein join zu der entity erstellt werden soll
                                var newJoin = {};
                                var selectedJoinEntity = crudeSchema && crudeSchema.find(function (elem) { return elem.name === joinEntity; });
                                var urlEntity = selectedJoinEntity && selectedJoinEntity.outgoingReferences.find(function (elem) { return (elem.targetEntity === mainEntity && elem.sourceColumn === props.embeddingEntityFilter.key); });
                                var tabEntity = selectedJoinEntity && selectedJoinEntity.outgoingReferences.find(function (elem) { return elem.targetEntity === entity && elem !== urlEntity; });
                                joinColumns && joinColumns.forEach(function (column) {
                                    if (tabEntity && column.name === tabEntity.sourceColumn) {
                                        newJoin[column.name] = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && entityElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                                    }
                                    if (urlEntity && column.name === urlEntity.sourceColumn) {
                                        newJoin[column.name] = props.mainEntityId;
                                    }
                                });
                                // speichern der neuen Einträge / temporäres Anlegen, bis entity create erfolgreich
                                if (props.mainEntityId !== 'new') {
                                    createEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, newJoin, fetchHeaders, setFetchResponse);
                                }
                                else {
                                    tempArray.push({ entity: joinEntity, data: newJoin });
                                    var newTempJoinData = __assign({}, temporaryJoinData);
                                    newTempJoinData[joinEntity] = tempArray;
                                    props.mainEntityId === 'new' && dispatch(crudeActions.setTemporaryJoinData(newTempJoinData));
                                }
                            } });
                    })))),
        singleEntity &&
            react_1.default.createElement(CrudeDialogComponent_1.default, { onClose: function () {
                    dispatch(crude_actions_1.setShowDialog(false));
                }, content: react_1.default.createElement(DataEditView_1.default, { disableJoinColumns: disabledJoinColumns, embeddingEntityFilter: props.embeddingEntityFilter, dataViewType: commonTypes_1.DataViewType.simpleView, entity: singleEntity.entity, id: singleEntity.id, treeViewLevel: props.treeViewLevel + 1, hideBackButton: true, showInPopup: true }) })));
};
exports.default = ResponsiveJoinEntity;
